import api from '../../../services/api';

class BudgetQuotationService {
  async getQuotations() {
    try {
      const response = await api.get('/inventory/budget');
      return response.data;
    } catch (error) {
      console.error('Error fetching budget quotations:', error);
      throw error;
    }
  }

  async getNextQuotationNo(type = 'final') {
    try {
      const response = await api.get(`/inventory/budget/next-no?type=${type}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching next quotation no:', error);
      throw error;
    }
  }

  async saveQuotation(data) {
    try {
      const response = await api.post('/inventory/budget', data);
      return response.data;
    } catch (error) {
      console.error('Error saving budget quotation:', error);
      throw error;
    }
  }

  async getAddCustomers() {
    try {
      const response = await api.get('/master_qos/add_customer');
      return response.data;
    } catch (error) {
      console.error('Error fetching add customers:', error);
      throw error;
    }
  }

  async saveAddCustomer(data) {
    try {
      const response = await api.post('/master_qos/add_customer', data);
      return response.data;
    } catch (error) {
      console.error('Error saving add customer:', error);
      throw error;
    }
  }

  async uploadPdf(id, pdfBlob, status) {
    try {
      const formData = new FormData();
      formData.append('pdf', pdfBlob, 'budget_quotation.pdf');
      if (status) {
        formData.append('status', status);
      }

      const response = await api.post(`/inventory/budget/${id}/pdf`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading PDF:', error);
      throw error;
    }
  }

  async updateStatus(id, status) {
    try {
      const response = await api.put(`/inventory/budget/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating status:', error);
      throw error;
    }
  }

  async deleteQuotation(id) {
    try {
      const response = await api.delete(`/inventory/budget/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting quotation:', error);
      throw error;
    }
  }
}

export const budgetQuotationService = new BudgetQuotationService();
